module.exports = __webpack_public_path__ + "assets/devices/GEN_ZONE_EXPANDER-d68e93a41026e4798a94a27fc8342cc9.svg";